module.exports = __webpack_public_path__ + "static/media/81Dx4Nx5dTL._SL1500_.582923af.jpg";